import { render, staticRenderFns } from "./PushDisableControl.vue?vue&type=template&id=24f9c31c&scoped=true"
import script from "./PushDisableControl.vue?vue&type=script&lang=js"
export * from "./PushDisableControl.vue?vue&type=script&lang=js"
import style0 from "./PushDisableControl.vue?vue&type=style&index=0&id=24f9c31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f9c31c",
  null
  
)

export default component.exports